<template>
  <div class="main">
    <!-- 上部分 -->
    <div class="title">
      <span class="text">缴费凭证</span>
      <el-button type="primary" class="addButton" @click="add">添加</el-button>
    </div>
    <!-- 下部分 -->
    <!-- 表格 -->
    <div class="table">
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 99%;height: 530px;overflow-y: scroll;"
        :header-row-style="{color: '#666'}"
      >
        <el-table-column align="center" prop="orderNumber" label="序号" type="index" :index="increamentIndex" width="100"></el-table-column>
        <el-table-column align="center" prop="companyname" label="会员单位"></el-table-column>
        <el-table-column align="center" prop="year" label="缴费年份"></el-table-column>
        <el-table-column align="center" prop="amount" label="缴费金额"></el-table-column>
        <el-table-column align="center" prop="paydate" label="缴费日期"></el-table-column>
        <el-table-column align="center" prop="state" label="是否处理"></el-table-column>
      </el-table>
      <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as Cache from '../utils/cache'
import * as API from '../utils/apiService'

export default {
  data () {
    return {
      id: '',
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      state: ''// 待处理 0  已处理 1
    }
  },
  mounted () {
    this.asyncGetPayment()
  },
  methods: {
    // 序号自增
    increamentIndex (index) {
      return index + (this.currentPage - 1) * this.pageSize + 1
    },
    // 查询缴费凭证（分页）
    asyncGetPayment () {
      let params = {
        userid: Cache.getUserInfo().id
      }
      API.findOneInfo(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.id = resp.data.id
          let _params = {
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            membershipid: this.id,
            state: this.state
          }
          API.getPayment(_params).then(resp => {
            if (resp.resultCode === '0000') {
              this.tableData = resp.data.list
              this.total = resp.data.total
            }
          })
        }
      })
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.asyncGetPayment()
    },
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.asyncGetPayment()
    },
    add () {
      this.$router.push('/editPayment')
    }
  }
}
</script>

<style>
.addButton {
  margin-left: 78%;
}
</style>
